import React from 'react'
import { Alert, Form } from 'antd'
import { Formik } from 'formik'
import { object, string } from 'yup'
import { useDispatch, useSelector } from 'react-redux'

import { Button, Text } from 'src/components/Ant'
import { ApplicationState } from 'src/store'
import { authForgotPassword } from 'src/core/store/ducks/auth/actions'
import { Input } from 'src/components/Formik'

import * as CSS from './styles'

interface Props {
  loading: boolean
  shareUsername: (value?: string) => string
  toggle: () => void
}

export default function ForgotPassword({
  loading,
  shareUsername,
  toggle
}: Props) {
  const { auth } = useSelector((state: ApplicationState) => ({
    auth: state.auth
  }))
  const dispatch = useDispatch()

  return (
    <Formik
      initialValues={{ username: shareUsername() }}
      onSubmit={({ username }) =>
        dispatch(
          authForgotPassword({
            username: username.trim().toLowerCase()
          })
        )
      }
      validationSchema={object().shape({
        username: string()
          .trim()
          .matches(
            /[A-Za-z0-9]{1,}@{1}[A-Za-z0-9.]{1,}/,
            'web.login.username.invalid'
          )
          .required('common.required')
      })}
      render={formikProps => (
        <CSS.WrapForm onSubmit={formikProps.handleSubmit}>
          {auth.forgot_password && (
            <Form.Item>
              <Alert
                message={auth.forgot_password.message}
                type={auth.forgot_password.type}
              />
            </Form.Item>
          )}
          <Input
            autoFocus
            data-test-id="login-forgot-my-password-username"
            formikProps={formikProps}
            label="web.login.username.title"
            name="username"
            onChange={value => {
              shareUsername(value.target.value)
            }}
            placeholder="web.login.username.placeholder"
            prefix={<CSS.WrapIcon type="user" />}
          />
          <CSS.Message>
            <Text title="web.login.forgot-password-message" />
          </CSS.Message>
          <Form.Item>
            <CSS.WrapLink title="common.actions.back" onClick={toggle} />
            <Button
              block
              data-test-id="login-forgot-my-password-submit"
              htmlType="submit"
              loading={loading}
              title="common.actions.send"
            />
          </Form.Item>
        </CSS.WrapForm>
      )}
    />
  )
}
